//#region Libraries
import styled from "styled-components";
//#endregion

export const Image = styled.img`
    min-width: 140px;
    ${(({ errorType }) => errorType !== 2 ? "" : `
    width: 100px;
    margin-top: 20px;
    ` )}
`;